import { flow } from 'fp-ts/function';
import { pipe } from 'fp-ts/lib/function';
import { createAuthorizedGetRequest, decode, fetchApi } from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import { integrationPropertyDetailedCodec, listCodec } from './codec';

const baseUrl = '/v2/integrations/properties';
const recordUrl = (id: string): string => `${baseUrl}/${id}`;

export const list = () => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(integrationPropertyDetailedCodec)),
);
